import type {Recipe} from './types';

export const rigatoniCipolla: Recipe = {
    id: 22,
    key: "rigatoniCipolla",
    pictures: [
        {index: 0, url: "https://www.example.com/rigatoni-alla-cipolla.jpg"},
    ],
    i18n: {
        IT: {
            title: "Rigatoni alla cipolla",
            servings: "Per 4 persone",
            ingredients: [
                "Rigatoni 500 g",
                "Pomodorini ciliegino 300 g",
                "3 Cipolle",
                "50 g Burro ",
                "Olio extravergine d'oliva q.b.",
                "100 ml Latte intero",
                "Zucchero q.b.",
                "Sale q.b.",
            ],
            steps: [
                "Per preparare i rigatoni alla cipolla, inizia scaldando una padella con olio e burro a fuoco lento, finché il burro non si sarà sciolto.",
                "Aumenta la fiamma e aggiungi i pomodorini precedentemente tagliati a metà. Aggiungi un po' di zucchero e cuoci fino a quando il sugo si sarà addensato.",
                "Aggiungi le cipolle affettate e il sale, copri e cuoci a fuoco lento per circa 30 minuti.",
                "Verso la fine della cottura, aggiungi il latte intero e continua a cuocere a fuoco lento fino a quando il latte sarà evaporato.",
                "Cuoci i rigatoni in abbondante acqua salata e scolali al dente. Trasferisci la pasta nella padella con il sugo e aggiungi un po' di acqua di cottura. Mescola bene e servi immediatamente.",
            ],
            pictures: [
                {index: 0, url: "https://www.example.com/rigatoni-alla-cipolla.jpg"},
            ],
        },
        EN: {
            title: "Rigatoni with Onion Sauce",
            servings: "For 4 people",
            ingredients: [
                "Rigatoni 500 g",
                "Cherry tomatoes 300 g",
                "3 Onions",
                "50 g Butter ",
                "Extra virgin olive oil to taste",
                "100 ml Whole milk",
                "Sugar to taste",
                "Salt to taste",
            ],
            steps: [
                "To prepare rigatoni with onion sauce, start by heating a pan with oil and butter over low heat until the butter melts.",
                "Increase the heat and add the halved cherry tomatoes. Add a pinch of sugar and cook until the sauce thickens.",
                "Add the sliced onions and salt, cover, and cook on low heat for about 30 minutes.",
                "Towards the end of cooking, add the whole milk and continue cooking on low heat until the milk evaporates.",
                "Cook the rigatoni in salted boiling water and drain it al dente. Transfer the pasta to the pan with the sauce, add a little cooking water, and mix well. Serve immediately.",
            ],
            pictures: [
                {index: 0, url: "https://www.example.com/rigatoni-with-onion-sauce.jpg"},
            ],
        },
        PL: {
            title: "Rigatoni z sosem cebulowym",
            servings: "Dla 4 osób",
            ingredients: [
                "Rigatoni 500 g",
                "Pomidorki koktajlowe 300 g",
                "3 Cebule",
                "50 g Masło ",
                "Oliwa z oliwek extra virgin do smaku",
                "100 ml Pełne mleko",
                "Cukier do smaku",
                "Sól do smaku",
            ],
            steps: [
                "Aby przygotować rigatoni z sosem cebulowym, zacznij od podgrzania oliwy i masła na patelni na małym ogniu, aż masło się rozpuści.",
                "Zwiększ ogień i dodaj przekrojone na pół pomidorki koktajlowe. Dodaj szczyptę cukru i gotuj, aż sos zgęstnieje.",
                "Dodaj pokrojone w plastry cebule i sól, przykryj i gotuj na wolnym ogniu przez około 30 minut.",
                "Pod koniec gotowania dodaj pełne mleko i gotuj na wolnym ogniu, aż mleko wyparuje.",
                "Gotuj rigatoni w osolonej, wrzącej wodzie i odcedź al dente. Przełóż makaron na patelnię z sosem, dodaj trochę wody z gotowania i dobrze wymieszaj. Podawaj od razu.",
            ],
            pictures: [
                {index: 0, url: "https://www.example.com/rigatoni-z-sosem-cebulowym.jpg"},
            ],
        },
    },
};
